<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <!--111-->
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
          <a-input :disabled="true" v-model="model.departName" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分管职位">
          <a-select
            placeholder="请选择分管角色"
            :default-active-first-option="false"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            v-model="model.type"
            :disabled="true"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option v-for="d in typeDS" :key="d.code">{{ d.value }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="replaceUser" :labelCol="labelCol" :wrapperCol="wrapperCol" label="原分管人员">
          <a-input :disabled="true" v-model="model.userBefore" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分管人员">
          <a-select
            show-search
            v-decorator="['userId', validatorRules.userId]"
            style="width: 100%"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @search="handleUserSearch"
          >
            <a-select-option value>请选择</a-select-option>
            <a-select-option v-for="(item, index) in userList" :key="index" :value="item.userId">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>

        <!--        <a-form-item-->
        <!--            :labelCol="labelCol"-->
        <!--            :wrapperCol="wrapperCol"-->
        <!--            label="分管开始时间">-->
        <!--          <a-date-picker-->
        <!--              showTime-->
        <!--              format="YYYY-MM-DD HH:mm:ss"-->
        <!--              style="width: 100%"-->
        <!--              v-decorator="[ 'beginTime',validatorRules.beginTime]"-->
        <!--              :disabled-date="disabledDate"-->
        <!--          />-->
        <!--        </a-form-item>-->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { getAction, postAction } from '@/api/manage.js'
import moment from 'moment'

export default {
  name: 'DepartManagerHisModal',
  components: {
    moment
  },
  data() {
    return {
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      replaceUser: {}, //将要被替换的用户
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        type: { rules: [{ required: true, message: '请选择分管职位!' }] },
        userId: { rules: [{ required: true, message: '请选择分管人员!' }] },
        beginTime: { rules: [{ required: true, message: '请选择分管开始时间!' }] }
      },
      typeDS: [],
      userList: []
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      return current > moment().endOf('day')
    },
    handleUserSearch(value) {
      this.userList = []
      this.getUserList(value)
    },
    getUserList(value) {
      let params = {
        realname: value ? value : ''
      }
      getAction('/api/sys/user/getAtlxUserList', params).then((res) => {
        console.log(res)
        let resp = res.result.records
        resp.map((el) => {
          this.userList.push({
            name: el.username + '（' + el.realname + '）',
            userId: el.id
          })
        })
      })
    },
    show(depart, type, replaceUser) {
      this.form.resetFields()
      this.model = {
        departId: depart.id,
        departName: depart.departName,
        type: type,
        userBefore: '无'
      }
      if (replaceUser) {
        this.$set(this.model, 'userBefore', replaceUser.username + '（' + replaceUser.realname + '）')
      }
      this.replaceUser = replaceUser
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue()
      })

      getAction('api/common/select/byType/SysDepartManagerHisEnum').then((res) => {
        if (res.success) {
          this.$nextTick(() => {
            this.typeDS = res.result
          })
        } else {
          this.$message.error(res.message)
        }
      })

      this.getUserList()
    },
    // 确定
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          console.log(this.model)
          that.confirmLoading = true
          let formData = Object.assign(this.model, values)
          formData.beginTime = moment(formData.beginTime).format('YYYY-MM-DD HH:mm:ss')
          formData.replaceUserId = this.replaceUser ? this.replaceUser.userId : ''
          let obj
          console.log(formData)
          postAction('api/sysdepartmanagerhis/add', formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.close()
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    // 关闭
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.userList = []
      this.visible = false
    }
  }
}
</script>
